'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Reminder = require('./Reminder');

var _Reminder2 = _interopRequireDefault(_Reminder);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'callout keep_in_mind';

function KeepInMind(_ref) {
  var title = _ref.title,
      description = _ref.description,
      reminders = _ref.reminders;

  //if (reminders.length) {
  if (false) {
    return _react2.default.createElement(
      'div',
      { className: CLASS_NAME },
      _react2.default.createElement(
        'h2',
        null,
        title
      ),
      _react2.default.createElement(
        'p',
        null,
        description
      ),
      _react2.default.createElement(
        'ul',
        { className: 'error' },
        reminders.map(function (reminder, key) {
          return _react2.default.createElement(_Reminder2.default, {
            key: key,
            reminder: reminder
          });
        })
      )
    );
  }

  return _react2.default.createElement('div', null);
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(KeepInMind);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/KeepInMind/KeepInMind.jsx
// module id = 1078
// module chunks = 0